import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppResource } from '../core/conf/app_conf';
import { SessionService } from '../services/session.service';

function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

// Reemplaza al TokenGuard de v0.0.31.
function hasSessionOrRedirect(state: RouterStateSnapshot): boolean {
  const router = inject(Router);

  if (inject(SessionService).hasExistingSession()) {
    return true;
  }

  router.navigate([AppResource.pathSession], {
    queryParams: { returnUrl: state.url }
  });
  return false;
}

export const ConditionalAuthGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const initialHasStatus = sessionStorage.getItem('initial_has_status') === 'true';
  if (initialHasStatus || isInIframe()) {
    return true;
  }

  return hasSessionOrRedirect(state);
};
